// src/components/ProtectedRoute/Admin/Consoles/Pages/ResearchersConsole.jsx
import React from "react";
import ConsolePageFrame from "../Framework/ConsolePageFrame";
import researchersPlugin from "../Plugins/researchers.plugin";
import DialogResearcher from "../../Dialogs/DialogResearcher";

export default function ResearchersConsole() {
  return (
    <ConsolePageFrame
      title="Researchers"
      plugin={researchersPlugin}
      searchPlaceholder="Search by name / alias / ORCID"
      columnsBuilder={({ onEdit }) => researchersPlugin.columns({ onEdit })}
      renderAddDialog={({ onClose }) => (
        <DialogResearcher open onClose={onClose} researcherId={null} />
      )}
      renderEditDialog={({ row, onClose }) => (
        <DialogResearcher open onClose={onClose} researcherId={row?.id ?? null} />
      )}
      toastMessages={{ create: "Researcher created", update: "Researcher updated" }}
      onRowClick={() => {}}
    />
  );
}
